import * as React from "react";
import { useState } from "react";
import { Box, Button, Chip, Paper, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@material-ui/core";
import { useNotify } from "react-admin";
import { cloError, cloGet, ENDPOINTS, formatDate } from "./api";

const CustomerLookupTab: React.FC = () => {
  const notify = useNotify();
  const [userId, setUserId] = useState("");
  const [result, setResult] = useState<{ campaigns: any[]; history: any[] } | null>(null);

  const search = async () => {
    try {
      const res = await cloGet(ENDPOINTS.CLO_COHORT_MEMBERS, { userId: Number(userId) });
      setResult(res.data);
    } catch (e) {
      notify(cloError(e), "warning");
    }
  };

  return (
    <Paper>
      <Box p={2} display="flex" alignItems="center" style={{ gap: 16 }}>
        <TextField label="User ID" value={userId} onChange={(e) => setUserId(e.target.value)} onKeyDown={(e) => e.key === "Enter" && search()} />
        <Button color="primary" variant="contained" disabled={!userId.trim()} onClick={search}>Look up</Button>
      </Box>
      {result && (
        <>
          <Box px={2}><Typography variant="subtitle1">Cohort per campaign</Typography></Box>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Campaign</TableCell>
                <TableCell>Cohort</TableCell>
                <TableCell>Since</TableCell>
                <TableCell>Set by</TableCell>
                <TableCell>Rules</TableCell>
                <TableCell>Offers</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {result.campaigns.map((c) => (
                <TableRow key={c.campaign_id}>
                  <TableCell>{c.retailer_name} · {c.campaign_name}</TableCell>
                  <TableCell>{c.cohort || (c.trigger_type === "leave" ? "Left" : "No offer")}</TableCell>
                  <TableCell>{formatDate(c.assigned_at)}</TableCell>
                  <TableCell>{c.trigger_type || "—"}</TableCell>
                  <TableCell>{c.definition_version ? `v${c.definition_version}` : "—"}</TableCell>
                  <TableCell>
                    {Number(c.targeting_suppressed) ? <Chip size="small" label="Hidden: bank consent lapsed" /> : "Shown"}
                  </TableCell>
                </TableRow>
              ))}
              {result.campaigns.length === 0 && <TableRow><TableCell colSpan={6} align="center">Not in any campaign</TableCell></TableRow>}
            </TableBody>
          </Table>
          <Box px={2} mt={2}><Typography variant="subtitle1">History</Typography></Box>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>When</TableCell>
                <TableCell>Campaign</TableCell>
                <TableCell>From</TableCell>
                <TableCell>To</TableCell>
                <TableCell>Why</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {result.history.map((h) => (
                <TableRow key={h.id}>
                  <TableCell>{formatDate(h.createdAt)}</TableCell>
                  <TableCell>{h.campaign_name}</TableCell>
                  <TableCell>{h.old_cohort || "—"}</TableCell>
                  <TableCell>{h.new_cohort || "—"}</TableCell>
                  <TableCell>{h.trigger_type}{Number(h.targeting_suppressed) ? " · offers hidden" : ""}</TableCell>
                </TableRow>
              ))}
              {result.history.length === 0 && <TableRow><TableCell colSpan={5} align="center">No changes yet</TableCell></TableRow>}
            </TableBody>
          </Table>
        </>
      )}
    </Paper>
  );
};

export default CustomerLookupTab;
